// extracted by mini-css-extract-plugin
export default {"Form":"DVzOvGKo","ModalForm":"svo0mZMl"};